import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c50ad2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin": "15px 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_AttachmentCpt = _resolveComponent("AttachmentCpt");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      title: "产品信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "产品名称",
        value: $data.production.productName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "成立日",
        value: $data.production.foundDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "开放日",
        value: $data.production.openDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "封帐日",
        value: $data.production.raiseEndDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "风险等级",
        value: _ctx.formatSelectColumn($data.codeResItems, 'riskGrade', {
          riskGrade: $data.production.riskGrade
        })
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "客户信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "客户姓名",
        value: $data.customer.chnName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "预约额度",
        value: $data.appointment.amount + '元'
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "付款信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_form, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.paymentAcc,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.paymentAcc = $event),
          required: "",
          name: "paymentAcc",
          label: "打款账号",
          placeholder: "请输入打款账号",
          rules: [{
            required: true,
            message: '请输入打款账号'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.paymentDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.paymentDate = $event),
          required: "",
          name: "paymentDate",
          label: "打款时间",
          placeholder: "请输入打款时间",
          rules: [{
            required: true,
            message: '请输入打款时间'
          }],
          onClick: _cache[2] || (_cache[2] = $event => $options.onPopupDateTimeSelectClick('paymentDate'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_cell, {
          title: "打款凭证",
          value: ""
        }, {
          default: _withCtx(() => [$data.appointment.status == '01' ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            style: {
              "width": "50%"
            },
            type: "primary",
            icon: "plus",
            loading: $data.btnLoading,
            onClick: $options.imgUpload
          }, {
            default: _withCtx(() => [_createTextVNode(" 上传 ")]),
            _: 1
          }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), $data.appointment.status == '03' ? (_openBlock(), _createBlock(_component_van_button, {
            key: 1,
            type: "primary",
            onClick: $options.viewPayment
          }, {
            default: _withCtx(() => [_createTextVNode(" 查看凭证 ")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [$data.appointment.status == '01' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          style: {
            "width": "40%",
            "margin-right": "5px"
          },
          type: "primary",
          loading: $data.btnLoading,
          onClick: $options.onSave
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), $data.appointment.status == '01' ? (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          plain: "",
          style: {
            "width": "40%"
          },
          "native-type": "button",
          type: "danger",
          loading: $data.btnLoading,
          onClick: $options.onSubmit
        }, {
          default: _withCtx(() => [_createTextVNode(" 撤销 ")]),
          _: 1
        }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_AttachmentCpt, {
        ref: "AttachmentCpt1"
      }, null, 512)]),
      _: 1
    }), _createVNode(_component_AttachmentCpt, {
      isShow: $data.show,
      ref: "AttachmentCpt"
    }, null, 8, ["isShow"]), _createVNode(_component_PopupDatePickerCpt, {
      ref: "PopupDateTimeCpt",
      onOnSelectedChange: $options.onDateTimeSelectedChange
    }, null, 8, ["onOnSelectedChange"])]),
    _: 1
  });
}